import React, { useState } from "react";
import useSWR from "swr";
import axios from "axios";
import Lightbox from "yet-another-react-lightbox";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Captions from "yet-another-react-lightbox/plugins/captions";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import "../Components/css/Gallery.css";

const Gallery = () => {
    const [open, setOpen] = useState(false);
    const [index, setIndex] = useState(0);

    const fetcher = async (url) => {
        const response = await axios.get(url);
        return response.data;
    };

    const baseUrl = process.env.REACT_APP_BASE_URL;
    const school = process.env.REACT_APP_SCHOOL;
    const API_ENDPOINT = `${baseUrl}/${school}/items/gallery?fields=*.*.*`;

    const { data, error } = useSWR(API_ENDPOINT, fetcher);

    if (error) {
        return <div>Error loading data</div>;
    }

    if (!data) {
        return <div>Loading...</div>;
    }

    const images = data.data;

    const slides = images.map((item) => ({
        src: item?.photo?.data?.full_url?.replace('http://', 'https://'),
        alt: item?.title || "Gallery Image",
        description: item?.description || "",
    }));

    return (
        <div className="container-fluid">
            <div className="first">
                {images.map((item, i) => (
                    <div key={i} className="one  " onClick={() => { setOpen(true); setIndex(i); }}>
                        <img
                            src={item?.photo?.data?.full_url?.replace('http://', 'https://')}
                            className="mt-3 imght rounded-lg shadow-sm "
                            alt={`Gallery ${i}`}
                            style={{ cursor: "pointer" }}
                        />
                    </div>
                ))}
            </div>

            {open && (
                <Lightbox
                    open={open}
                    close={() => setOpen(false)}
                    slides={slides}
                    index={index}
                    plugins={[Thumbnails, Captions]}
                />
            )}
        </div>
    );
};

export default Gallery;
